export const printerMachineTasksColumns = [
  { label: 'ID da Task', value: 'id' },
  { label: 'Status', value: 'status' },
  { label: 'Motivo da falha', value: 'failure_reason' },
  { label: 'Criada em', value: 'created_at' },
];